function InicioCompStreaming() {


    return (
      <>
        <div className="full-width-imageStreaming">
          <div className="izquierdaBannerStreaming">
            <div className="imagenIzquierdaComtenedorStreaming">
              <img src="./img/Inicio/icoWifi.png" />
            </div>
            <div className="textoContenedorIzquierdaStreaming">
              <div className="textoIz1Streaming">
                <p>Speedy Fibra</p>
              </div>
              <div className="textoIz2Streaming">
                <p>La fibra que todos quieren</p>
              </div>
            </div>
          </div>
          <div className="derechaBannerStreaming">
            <div className="textoDer1Streaming">
              <p>250 Megas</p>
            </div>
            <div className="textoDer2Streaming">
              <p>$25.20/mes</p>
            </div>
            <div className="textoDer3Streaming">
              <p>Contrátalo ahora</p>
            </div>
            <a href="#" class="button-link">Revisa tu factibilidad</a>
          </div>
        </div>
        <div class="link-container">
          <a href="./#" class="link medios dos">
            <img src="./img/Inicio/internethogaractiveNegro.svg" alt="Imagen 1" />
            Internet Hogar
          </a>
          <a href="./corporativo" class="link medios tres">
            <img src="./img/Inicio/internet2.svg" alt="Imagen 2" />
           Internet Corporativo
          </a>
          <a href="./streaming" class="link medios">
            <img src="./img/Inicio/internet4Azul.png" alt="Imagen 3" />
            Streaming
          </a>
          <a href="./dual" class="link ultimo">
            <img src="./img/Inicio/internet3.png" alt="Imagen 4" />
            Dual Pack
          </a>
        </div>
        <div className="texto arriba">
          Internet Hogar Fibra Óptica
        </div>
        <div className="texto abajo">
          Mejor experiencia de internet con más velocidad y estabilidad
        </div>
        <div className="planesContenedor">
          <div className="planUno">
            <div className="espacioUltima"></div>
            <div className="primeraFila">
              <div className="normal">Internet</div><div className="negrita">Fibra</div> <br />
            </div>
            <div className="primeraFila"><div className="negrita">150 Megas</div></div><br />
            <div className="primeraFila"><img src="./img/Planes/iconoPlanes1y3.png" />Router</div><br />
            <div className="capsulaPlan"><div className="capsulaColor">20% dcto.</div><div className="capsulaSinColor"> Oferta Online</div></div><br />
            <div className="primeraFila"><div className="precio">$22.40/mes</div><br /></div>
            <div className="primeraFila">Por 4 meses, luego<div className="negritaPeque">$26.48/mes</div><br /></div>
            <div className="contenedorLoQuiero">
              <div className="capsulaQuiero"><a>Lo quiero</a></div>
            </div><br />
            <div className="primeraFila"><img src="./img/Planes/iconoPlanes2.png" />Velocidad simétrica <br /></div>
            <div className="primeraFila masEspacio"><p>Hasta <strong>150Mbps</strong> de subida</p><br /></div>
            <div className="primeraFila masEspacio">y bajada</div>
            <div className="espacioUltima"></div>
            <div className="lineaHorizontal" />
            <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes1y3.png" />Router principal  <div className="negritaPeque">incluido</div> <br /></div>
            <div className="lineaHorizontal" />
            <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes3.png" />No incluye <div className="negritaPeque">extensor de señal </div><br /></div>
            <div className="lineaHorizontal" />
            <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes4.png" />Costo de instalación <div className="negritaPeque">$0</div></div>
          </div>
          <div className="planDos">
            <div className="espacioUltima"></div>
            <div className="primeraFila">
              <div className="normal">Internet</div><div className="negrita">Fibra</div> <br />
            </div>
            <div className="primeraFila"><div className="negrita">200 Megas</div></div><br />
            <div className="primeraFila"><img src="./img/Planes/iconoPlanes1y3.png" />Router</div><br />
            <div className="capsulaPlan"><div className="capsulaColor">25% dcto.</div><div className="capsulaSinColor"> Oferta Online</div></div><br />
            <div className="primeraFila"><div className="precio">$22.50/mes</div><br /></div>
            <div className="primeraFila">Por 4 meses, luego<div className="negritaPeque">$28.13/mes</div><br /></div>
            <div className="contenedorLoQuiero"><div className="capsulaQuiero"><a>Lo quiero</a></div></div><br />
            <div className="primeraFila"><img src="./img/Planes/iconoPlanes2.png" />Velocidad simétrica <br /></div>
            <div className="primeraFila masEspacio"><p>Hasta <strong>200Mbps</strong> de subida</p><br /></div>
            <div className="primeraFila masEspacio">y bajada</div>
            <div className="espacioUltima"></div>
            <div className="lineaHorizontal" />
            <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes1y3.png" />Router principal  <div className="negritaPeque">incluido</div> <br /></div>
            <div className="lineaHorizontal" />
            <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes3.png" />No incluye <div className="negritaPeque">extensor de señal </div><br /></div>
            <div className="lineaHorizontal" />
            <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes4.png" />Costo de instalación <div className="negritaPeque">$0</div></div>
          </div>
          <div className="planTres">
            <div className="espacioUltima"></div>
            <div className="primeraFila">
              <div className="normal">Internet</div><div className="negrita">Fibra</div> <br />
            </div>
            <div className="primeraFila"><div className="negrita">250 Megas</div></div><br />
            <div className="primeraFila"><img src="./img/Planes/iconoPlanes1y3.png" />Router</div><br />
            <div className="capsulaPlan"><div className="capsulaColor">25% dcto.</div><div className="capsulaSinColor"> Oferta Online</div></div><br />
            <div className="primeraFila"><div className="precio">$25.20/mes</div><br /></div>
            <div className="primeraFila">Por 4 meses, luego<div className="negritaPeque">$31.50/mes</div><br /></div>
            <div className="contenedorLoQuiero"><div className="capsulaQuiero"><a>Lo quiero</a></div></div><br />
            <div className="primeraFila"><img src="./img/Planes/iconoPlanes2.png" />Velocidad simétrica <br /></div>
            <div className="primeraFila masEspacio"><p>Hasta <strong>250Mbps</strong> de subida</p><br /></div>
            <div className="primeraFila masEspacio">y bajada</div>
            <div className="espacioUltima"></div>
            <div className="lineaHorizontal" />
            <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes1y3.png" />Router principal  <div className="negritaPeque">incluido</div> <br /></div>
            <div className="lineaHorizontal" />
            <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes4.png" />Costo de instalación <div className="negritaPeque">$0</div></div>
          </div>
          <div className="planCuatro">
            <div className="espacioUltima"></div>
            <div className="primeraFila">
              <div className="normal">Internet</div><div className="negrita">Fibra</div> <br />
            </div>
            <div className="primeraFila"><div className="negrita">250 Megas</div></div><br />
            <div className="primeraFila"><img src="./img/Planes/iconoPlanes1y3.png" />Router</div><br />
            <div className="capsulaPlan"><div className="capsulaColor">25% dcto.</div><div className="capsulaSinColor"> Oferta Online</div></div><br />
            <div className="primeraFila"><div className="precio">$25.20/mes</div><br /></div>
            <div className="primeraFila">Por 4 meses, luego<div className="negritaPeque">$31.50/mes</div><br /></div>
            <div className="contenedorLoQuiero"><div className="capsulaQuiero"><a>Lo quiero</a></div></div><br />
            <div className="primeraFila"><img src="./img/Planes/iconoPlanes2.png" />Velocidad simétrica <br /></div>
            <div className="primeraFila masEspacio"><p>Hasta <strong>250Mbps</strong> de subida</p><br /></div>
            <div className="primeraFila masEspacio">y bajada</div>
            <div className="espacioUltima"></div>
            <div className="lineaHorizontal" />
            <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes1y3.png" />Router principal  <div className="negritaPeque">incluido</div> <br /></div>
            <div className="lineaHorizontal" />
            <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes3.png" />No incluye <div className="negritaPeque">extensor de señal </div><br /></div>
            <div className="lineaHorizontal" />
            <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes4.png" />Costo de instalación <div className="negritaPeque">$0</div></div>
          </div>
        </div>
      </>
    );
  }
  
  export default InicioCompStreaming;
  